import { useState } from "react";
import { useLock } from "@/context/LockContext";
import { Lock } from "lucide-react";

export default function LockScreen() {
  const { locked, unlock } = useLock();
  const [pin, setPin] = useState("");
  const [error, setError] = useState(false);

  if (!locked) return null;

  const onChange = (v) => {
    const digits = v.replace(/\D/g, "").slice(0, 8);
    setPin(digits);
    setError(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (pin.length < 4) return;
    const ok = await unlock(pin);
    if (!ok) {
      setError(true);
      setPin("");
    }
  };

  return (
    <div
      data-testid="lock-screen"
      className="fixed inset-0 z-[200] grid place-items-center px-6"
      style={{ background: "rgba(20,14,10,0.96)", backdropFilter: "blur(10px)" }}
    >
      <form onSubmit={submit} className="glass rounded-3xl p-10 w-full max-w-sm text-center gold-glow border border-[#D4AF37]/30">
        <div className="mx-auto h-16 w-16 rounded-full bg-[#D4AF37]/10 grid place-items-center text-[#D4AF37]">
          <Lock size={28} />
        </div>
        <h1 className="mt-6 serif text-3xl text-[#F7F1E6]">Your sanctuary is locked</h1>
        <p className="mt-2 text-[#B4A897] text-sm">Enter your passcode to continue.</p>
        <input
          data-testid="lock-pin-input"
          type="password"
          inputMode="numeric"
          autoFocus
          value={pin}
          onChange={(e) => onChange(e.target.value)}
          placeholder="••••"
          className="mt-8 w-full text-center tracking-[0.6em] text-2xl bg-white/[0.04] border border-white/10 rounded-2xl px-4 py-4 text-[#F7F1E6] outline-none focus:border-[#D4AF37]/60 transition-colors duration-300"
        />
        {error && (
          <p data-testid="lock-error" className="mt-3 text-[#C1272D] text-sm">That passcode didn't match. Try again.</p>
        )}
        <button
          data-testid="lock-submit"
          type="submit"
          disabled={pin.length < 4}
          className="mt-6 w-full rounded-full bg-[#D4AF37] text-[#17100C] px-6 py-3 font-medium hover:bg-[#e6c860] transition-colors duration-300 disabled:opacity-40"
        >
          Unlock
        </button>
      </form>
    </div>
  );
}
